var map = {
	"./logos-maieutica_AVIVA.svg": 6720,
	"./logos-maieutica_Albert Sabin.svg": 5022,
	"./logos-maieutica_Aubrick.svg": 2148,
	"./logos-maieutica_Beacon.svg": 8699,
	"./logos-maieutica_Camb.svg": 8286,
	"./logos-maieutica_Carandá.svg": 5923,
	"./logos-maieutica_Cervantes.svg": 5046,
	"./logos-maieutica_Chapel.svg": 34,
	"./logos-maieutica_Colegio Augusto Laranja.svg": 9542,
	"./logos-maieutica_Colegio Einstein Semente.svg": 4939,
	"./logos-maieutica_Colégio Elvira Brandão.svg": 8727,
	"./logos-maieutica_Colégio Santa Amalia.svg": 8067,
	"./logos-maieutica_Colégio Santa Cruz.svg": 5094,
	"./logos-maieutica_Colégio Santo Americo.svg": 2020,
	"./logos-maieutica_Colégio São Luis.svg": 4763,
	"./logos-maieutica_Ekoa.svg": 403,
	"./logos-maieutica_Escola Americana de Vitória.svg": 704,
	"./logos-maieutica_Escola Carlitos.svg": 3091,
	"./logos-maieutica_Escola Cidade Jardim PlayPen.svg": 2652,
	"./logos-maieutica_Escola Concept.svg": 4568,
	"./logos-maieutica_Escola Eleva.svg": 4827,
	"./logos-maieutica_Escola Internacional Alphaville.svg": 7931,
	"./logos-maieutica_Escola Mobile.svg": 7642,
	"./logos-maieutica_Escola Projeto Vida.svg": 601,
	"./logos-maieutica_Escola Santi.svg": 7319,
	"./logos-maieutica_Escola Viva.svg": 2816,
	"./logos-maieutica_Escola do Futuro.svg": 2442,
	"./logos-maieutica_Graded.svg": 4040,
	"./logos-maieutica_Iavne.svg": 9922,
	"./logos-maieutica_Internacional School Of Curitiba.svg": 5924,
	"./logos-maieutica_Liceu Albert Sabin.svg": 9268,
	"./logos-maieutica_Magister.svg": 8597,
	"./logos-maieutica_MapleBear.svg": 3852,
	"./logos-maieutica_Oswald-de-Andrade.svg": 1657,
	"./logos-maieutica_Pueri Domus.svg": 4128,
	"./logos-maieutica_Red House Internacional School.svg": 4691,
	"./logos-maieutica_School of the Nations.svg": 2551,
	"./logos-maieutica_VeraCruz.svg": 6193,
	"./logos-maieutica_Vila.svg": 6213,
	"./logos-maieutica_Villa Global Education.svg": 1844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6739;